if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      
      this.nextButton?.addEventListener('click', ()=>{
        this.changeSlide('next')
         
     });


      
      this.prevButton?.addEventListener('click', ()=>{
        this.changeSlide('prev')
      });
    
      setInterval(() => {
        this.index == 0 ? this.changeSlide('next') : this.changeSlide('prev')
      }, 3000);
    }
    
    changeSlide(direction) {

      this.nextButton?.classList?.remove('announcement-bar__content-nav--disabled')
      this.prevButton?.classList?.remove('announcement-bar__content-nav--disabled')

      if ( direction == 'next' ) {
        this.index++;
      } else if ( direction == 'prev' ) {
        this.index--;
      }

      if ( this.index == this.length - 1 ) {
        this.nextButton?.classList?.add('announcement-bar__content-nav--disabled')
      } else if ( this.index == 0 ) {
        this.prevButton?.classList?.add('announcement-bar__content-nav--disabled')
      }

      this.slider?.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

    }

  }

  

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
    
	}

}

// var slideIndex = 0;
// showSlides();
// var slides,dots;

// function showSlides() {
//     var i;
//     slides = document.getElementsByClassName("announcement");
//     dots = document.getElementsByClassName("dot");
//     for (i = 0; i < slides.length; i++) {
//        slides[i].style.display = "none";  
//     }
//     slideIndex++;
//     if (slideIndex> slides.length) {slideIndex = 1}    
//     // for (i = 0; i < dots.length; i++) {
//     //     dots[i].className = dots[i].className.replace(" active", "");
//     // }
//     slides[slideIndex-1].style.display = "block";  
//     // dots[slideIndex-1].className += " active";
//     setTimeout(showSlides, 4000); // Change image every 8 seconds
// }

// function plusSlides(position) {
//     slideIndex +=position;
//     if (slideIndex> slides.length) {slideIndex = 1}
//     else if(slideIndex<1){slideIndex = slides.length}
//     for (i = 0; i < slides.length; i++) {
//        slides[i].style.display = "none";  
//     }
//     // for (i = 0; i < dots.length; i++) {
//     //     dots[i].className = dots[i].className.replace(" active", "");
//     // }
//     slides[slideIndex-1].style.display = "block";  
//     // dots[slideIndex-1].className += " active";
// }

// function currentSlide(index) {
//     if (index> slides.length) {index = 1}
//     else if(index<1){index = slides.length}
//     for (i = 0; i < slides.length; i++) {
//        slides[i].style.display = "none";  
//     }
//     // for (i = 0; i < dots.length; i++) {
//     //     dots[i].className = dots[i].className.replace(" active", "");
//     // }
//     slides[index-1].style.display = "block";  
//     // dots[index-1].className += " active";
// }





